import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "Pay-As-You-Go",
  "Or Monthly Membership",
  "Credits Never Expire",
  "Cancel Anytime",
  "Built for Business",
  "Clean English Text",
  "Vertical · Square · Wide",
];

export default function ValueMarquee() {
  return (
    <div
      data-testid="value-marquee"
      className="relative border-y border-white/10 bg-[#0a0a0a] py-7 overflow-hidden"
    >
      <Marquee speed={42} gradient={false} pauseOnHover={false}>
        {ITEMS.concat(ITEMS).map((item, i) => (
          <div key={i} className="flex items-center gap-10 px-10">
            <span className="font-display text-2xl md:text-3xl font-bold text-[#F4F4F0] tracking-tight whitespace-nowrap">
              {item}
            </span>
            <span className="text-[#D4AF37] text-3xl leading-none">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
